import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const OptInGetFreeMasterclassContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem;
  box-sizing: border-box;
  width: 100%;

  @media (max-width: ${layout.xs}) {
    padding: 0;

    .button-primary {
      padding: 9px 16px;
    }
  }
`;
